export const OWNER_RECURRING_FREQUENCIES = [
  { value: "weekly", label: "Semanal" },
  { value: "monthly", label: "Mensual" },
  { value: "quarterly", label: "Trimestral" },
  { value: "yearly", label: "Anual" },
];

export function recurringFrequencyLabel(value) {
  return OWNER_RECURRING_FREQUENCIES.find((row) => row.value === value)?.label || "Mensual";
}

export function dateInputValue(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
}

function daysInMonth(year, monthIndex) {
  return new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
}

export function legacyFirstDueDateInput(plan) {
  if (!plan) return "";
  if (plan.firstDueDate) return dateInputValue(plan.firstDueDate);
  const start = new Date(plan.startDate);
  if (Number.isNaN(start.getTime())) return "";
  const dueDay = Math.min(Math.max(Number(plan.dueDay) || 1, 1), 31);
  const candidateFor = (year, monthIndex) => new Date(Date.UTC(year, monthIndex, Math.min(dueDay, daysInMonth(year, monthIndex)), 12, 0, 0, 0));
  let candidate = candidateFor(start.getUTCFullYear(), start.getUTCMonth());
  const startDate = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate(), 12, 0, 0, 0));
  if (candidate < startDate) candidate = candidateFor(start.getUTCFullYear(), start.getUTCMonth() + 1);
  return dateInputValue(candidate);
}
